import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideBarClosed from "./SideBarClosed";
import SideBarOpen from "./SideBarOpen";
 
export default function SideBar() {
  const { sideMenuCollapsed } = useSelector((state) => state.global);
  const { user } = useSelector((state) => state.auth);
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  useEffect(() => {}, [sideMenuCollapsed]);



  if (sideMenuCollapsed) return <SideBarClosed />;

  return <SideBarOpen />;
}
